<template>

  <div :style="this.$store.getters.cancelRecurring ? 'display: flex; justify-content: center;' : null">

    <div
      id="vpay-payment-form"
      class="vpay"
      :style="this.$store.getters.cancelRecurring ? 'width: 50%;' : null"
    >

      <img
        v-if="$store.getters.client.id && $store.getters.account.settings.logo_url"
        :src="$store.getters.account.settings.logo_url"
        class="vpay__client-logo"
        :style="this.$store.getters.cancelRecurring ? 'margin: 0 auto; width: 65% !important;' : null"
      >

      <div class="vpay__inner">

        <transition
          v-if="$store.getters.errorScreen.enabled"
          name="next-step"
          mode="out-in"
          :key="$store.getters.errorScreen.enabled"
        >
          <div class="vpay__error-screen">
            <img
              class="vpay__error-image"
              :src="$store.getters.errorScreen.image"
            >
            <p
              class="vpay__error-message"
              v-html="$store.getters.errorScreen.message ? $store.getters.errorScreen.message : 'This page is currently down. Please try again later.'"
            ></p>
          </div>
        </transition>

        <div v-else>

          <transition
            name="next-step"
            mode="out-in"
            :key="currentComponent"
          >
            <component
              :is="currentComponent"
              @event="onComponentEvent"
            ></component>
          </transition>

          <footer v-if="$store.getters.showFooter">

            <el-row v-if="!$store.getters.embed && $store.getters.userIsLoggedIn">
              <p class="logged-in-as">Logged in as {{ $store.getters.user.first_name}} {{ $store.getters.user.last_name}}</p>
            </el-row>

            <el-row v-if="!$store.getters.embed && !$store.getters.userIsLoggedIn">
              <el-button
                class="vpay__button"
                type="text"
                @click="onClickLogInButton"
              >Log In</el-button>
              <el-button
                class="vpay__button"
                type="text"
                @click="onClickCreateAccountButton"
              >Create Account</el-button>
            </el-row>

            <el-row v-if="showPlatformInformation">
              <a
                class="powered-by-link"
                :href="$store.getters.platform.website_url"
                target="blank"
              ><img
                  class="powered-by-logo"
                  :src="$store.getters.platform.logo['payments-by-small'] + '?1'"
                  :title="$store.getters.platform.name"
                ></a>
              <el-button
                class="vpay__button terms-and-conditions-button"
                type="text"
                @click="onClickTermsAndConditionsButton"
              >Terms & Conditions</el-button>
            </el-row>

          </footer>

        </div>

      </div>

    </div>

  </div>
 
</template>

<script>
//import EditableValue from '@bit/simonburford.test.editable-value';

import SplashScreen from "@/components/SplashScreen.vue";

import TermsAndConditions from "@/components/TermsAndConditions.vue";

import LogIn from "@/components/LogIn.vue";
import CreateAccount from "@/components/CreateAccount.vue";

//import MyAccount from "@/components/MyAccount.vue";

import PaymentFormStep1 from "@/components/PaymentFormStep1";
import PaymentFormStep2 from "@/components/PaymentFormStep2";
import PaymentFormStep3 from "@/components/PaymentFormStep3";
import PaymentFormStep4 from "@/components/PaymentFormStep4";

import SuccessCancelRecurring from "@/components/SuccessCancelRecurring";
import CancelRecurring from "@/components/CancelRecurring";
import TransactionReceipt from "@/components/TransactionReceipt";

import JWT from "@/mixins/jwt";

export default {
  name: "PaymentForm",

  mixins: [JWT],

  components: {
    //EditableValue,

    SplashScreen,

    TermsAndConditions,

    LogIn,
    CreateAccount,

    //MyAccount,

    PaymentFormStep1,
    PaymentFormStep2,
    PaymentFormStep3,
    PaymentFormStep4,

    SuccessCancelRecurring,
    CancelRecurring,
    TransactionReceipt,
  },

  methods: {
    onClickLogInButton() {
      this.$store.commit("displayComponentName", "LogIn");
    },

    onClickCreateAccountButton() {
      this.$store.commit("displayComponentName", "CreateAccount");
    },

    onClickTermsAndConditionsButton() {
      this.$store.commit("displayComponentName", "TermsAndConditions");
    },

    onComponentEvent(e) {
      if (e.name == "next") {
        this.$store.commit("incrementPaymentStep");
      }
    },
  },

  computed: {
    showPlatformInformation() {
      return !this.url.searchParams.get("hosted");
    },

    accountButtonLabel() {
      if (this.$store.getters.userIsLoggedIn) {
        return `${this.$store.getters.user.first_name} ${this.$store.getters.user.last_name}`;
      }
      return "Log In";
    },

    currentComponent() {
      this.$errors.closeAll();
      if (this.loading) {
        return "SplashScreen";
      } else if (this.$store.getters.displayComponentName) {
        return this.$store.getters.displayComponentName;
      } else {
        return this.$store.getters.paymentStepComponentName;
      }
    },
  },

  created() {
    // If the URL includes an access token add it to the store
    // and make it a common request header.

	this.axios.defaults.headers.common["Vinteract-Platform-Token"] = "Zm9ybQ==";
	
    if (this.url) {
      this.$store.commit("iframeUrl", this.url);
    }

    if (this.url.searchParams.get("access-token")) {
      this.$store.commit(
        "accessToken",
        this.url.searchParams.get("access-token")
      );
      this.axios.defaults.headers.common["Vinteract-Access-Token"] =
        this.url.searchParams.get("access-token");
    }

    // from embed?

    if (this.url.searchParams.get("embed")) {
      this.$store.commit(
        "embed",
        this.url.searchParams.get("embed") == 'true'
      );
      this.axios.defaults.headers.common["Vinteract-Embed-Code"] =
        this.$store.getters.embed;
    }

    // If the URL includes a JWT token add it to the store
    // and

    if (!this.$store.getters.embed && this.url.searchParams.get("user-token")) {
      try {
        const jwtToken = this.url.searchParams.get("user-token");
        const decodedJwtToken = this.parseJwtToken(jwtToken);
        if (
          decodedJwtToken.hasOwnProperty("data") &&
          decodedJwtToken.data.hasOwnProperty("user")
        ) {
          this.$store.commit("user", decodedJwtToken.data.user);
          this.$store.commit("address", {
            street_1: this.$store.getters.user.street_1,
            city: this.$store.getters.user.city,
            state: this.$store.getters.user.state,
            postcode: this.$store.getters.user.postcode,
            country: this.$store.getters.user.country,
          });
          this.$store.commit("jwt", jwtToken);
        }
      } catch (e) {
      } finally {
      }
    }

    // decode the uri params

    if (this.url.searchParams.get("donation-causes")) {
      var donation_causes_data = atob(
        this.url.searchParams.get("donation-causes")
      ).split("&");

      if (donation_causes_data.length > 0) {
        var donationCauses = donation_causes_data[0].split("=")[1].split(",");
        var content_type = donation_causes_data[1].split("=")[1];
        var content_id = donation_causes_data[2].split("=")[1];

        if (donationCauses.length > 0) {
          this.$store.commit("donationCauses", donationCauses);
        }

        this.$store.commit("from_content_type", content_type);
        this.$store.commit("from_content_id", content_id);
      }
    }

    // Get account details.

    this.axios
      .get("account", { headers: this.$store.getters.requestHeaders, params: {url: document.referrer} })
      .then((r) => {
        // Update properties.

        if (!this.url.searchParams.get("session_token")) {
          this.loading = false;
        }

        this.$store.commit("client", r.data.client);

        this.$store.commit("account", r.data.payments.account);

        this.$store.commit("provider", r.data.payments.provider);

        this.$store.commit("platform", r.data.payments.platform);

        // Check if their account is active.

        if (r.data.payments.account.status !== "active") {
          this.$store.commit("errorScreen", {
            enabled: true,
            image:
              "https://pay.vinteract.com.au/img/hugo-under-construction.png",
            message: r.data.payments.account.status_message,
          });
        }

        // Check if the payment form has been disabled by the client

        if (r.data.payments.account.settings.disable_payment_form) {
          this.$store.commit("errorScreen", {
            enabled: true,
            image:
              "https://pay.vinteract.com.au/img/hugo-under-construction.png",
            message:
              r.data.payments.account.settings.disable_payment_form_message,
          });
        }

        // Receipt?

        if (this.url.searchParams.get("receipt")) {
          this.$store.commit(
            "receiptNumber",
            this.url.searchParams.get("receipt")
          );
          this.$store.commit("displayComponentName", "TransactionReceipt");
          this.$store.commit("showReceiptBackButton", false);
          this.$store.commit("showFooter", false);
        } else {
          this.$store.commit("showFooter", true);
        }

        // Cancel?

        if (this.url.searchParams.get("cancel_recurring")) {
          this.$store.commit(
            "cancelRecurring",
            this.url.searchParams.get("cancel_recurring")
          );
          this.$store.commit("displayComponentName", "CancelRecurring");
          this.$store.commit("showFooter", false);
        } else {
          this.$store.commit("showFooter", true);
        }
      })
      .catch((e) => {
        this.$store.commit("errorScreen", {
          enabled: true,
          image: "https://pay.vinteract.com.au/img/hugo-bad-gateway.png",
          message: "Uh oh... an unknown error has occurred.",
        });
      });

    // 3DS
    if (this.url.searchParams.get("session_token")) {
      this.loading = true;
      let formData = JSON.parse(localStorage.getItem("reddeData"));

      formData.need_to_verify = true;
      formData.session_token = this.url.searchParams.get("session_token");

      this.axios
        .post("transactions", [formData], {
          headers: this.$store.getters.requestHeaders,
          timeout: 60000,
        })
        .then((r) => {
          if (r.data.success) {
            this.$store.commit("transactionResponse", r.data);
            this.$store.commit("setPaymentStep", 4);
          }
          this.loading = false;
        })
        .catch((e) => {
          formData.need_to_verify = null;
          formData.session_token = null;

          if (this.url.searchParams.get("user-token")) {
            try {
              const jwtToken = this.url.searchParams.get("user-token");
              const decodedJwtToken = this.parseJwtToken(jwtToken);
              if (
                decodedJwtToken.hasOwnProperty("data") &&
                decodedJwtToken.data.hasOwnProperty("user")
              ) {
                this.$store.commit("user", decodedJwtToken.data.user);
                this.$store.commit("address", {
                  street_1: this.$store.getters.user.street_1,
                  city: this.$store.getters.user.city,
                  state: this.$store.getters.user.state,
                  postcode: this.$store.getters.user.postcode,
                  country: this.$store.getters.user.country,
                });
                this.$store.commit("jwt", jwtToken);
              }
            } catch (e) {
            } finally {
            }
          } else {
            this.$store.commit("user", formData.customer);
            this.$store.commit("address", formData.customer.address);
          }

          this.$store.commit(
            "userWillPayTheFees",
            formData.transaction.user_paid_fees
          );

          this.$store.commit("amount", formData.transaction.original_amount);
          this.$store.commit("selectedCause", formData.product);
          this.$store.commit("frequency", formData.transaction.frequency);
          this.$store.commit("notes", formData.transaction.notes);
          this.$store.commit("mobileNumberValidated", formData.customer.mobile);

          this.$store.commit(
            "from_content_type",
            formData.transaction.from_content_type
          );
          this.$store.commit(
            "from_content_id",
            formData.transaction.from_content_id
          );

          if (e.response) {
            if (e.response.hasOwnProperty("data")) {
              this.$store.commit("error3DS", e.response.data.message);
            } else {
              this.$store.commit(
                "error3DS",
                "An unknown error occurred while processing that transaction. Please try again."
              );
            }
          } else {
            this.$store.commit(
              "error3DS",
              "An unknown error occurred while processing that transaction. Please try again."
            );
          }

          this.$store.commit("setPaymentStep", 3);

          this.loading = false;
        })
        .finally(() => {});
    }
  },

  data() {
    return {
      url: new URL(window.location.href),
      loading: true,
    };
  },
};
</script>

<style>
@import url(https://fonts.googleapis.com/css?family=Muli:200,300,400,600,700,800,900);

@import url(https://fonts.googleapis.com/css?family=Montserrat:200,300,400,500,600,700,800,900);

* {
  font-family: "Montserrat", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  user-select: none;
  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: -moz-none;
  -webkit-user-select: none;
}

input,
input:before,
input:after {
  -webkit-user-select: initial;
  -khtml-user-select: initial;
  -moz-user-select: initial;
  -ms-user-select: initial;
  user-select: initial;
}

body {
  margin: 0;
  padding: 0;
}

ion-icon {
  position: relative;
  top: 2px;
  margin-right: 4px;
}

label {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 500;
}

h1 {
  font-size: 2em;
}

h2 {
  font-size: 1.5em;
}

h3 {
  font-size: 1.17em;
}

/*
		
		Transitions
		
	*/

/*
			Next Step
		*/

.next-step {
  backface-visibility: hidden;
}

.next-step-enter {
  transform: translateX(-100px);
  opacity: 0;
}

.next-step-enter-to {
  transform: translateX(0);
  opacity: 1;
}

.next-step-leave-to {
  transform: translateX(100px);
  opacity: 0;
}

.next-step-enter-active {
  transition: all 250ms;
  transition-timing-function: ease;
  transition-duration: 0.3s;
  overflow: hidden;
}

.next-step-leave-active {
  transition: all 250ms;
  transition-timing-function: ease;
}

/*
		V-Pay
	*/

.vpay {
  color: #2c3e50;
  min-height: 600px;
  position: relative;
}

.vpay__inner {
  padding: 20px;
  position: relative;
}

.vpay__client-logo {
  display: block;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.vpay__error-screen {
  padding: 20px;
  text-align: center;
}

.vpay__error-image {
  margin: 40px 0 0 0;
  width: 75%;
}

.vpay__error-message {
  margin: 40px 20px 0 20px;
  font-size: 14px;
}

.vpay__step {
}

.vpay__input-container {
  padding: 16px;
  padding-bottom: 0;
}

.vpay__input {
  display: block;
  padding: 20px;
  border: 0;
  color: #333333;
  font-size: 32px;
  font-weight: 400;
  width: 100%;
  text-align: center;
  /*box-sizing: border-box;*/
  border-radius: 4px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.vpay__input-note {
  text-align: center;
  font-size: 14px;
  /*color: #E6A23C;*/
  margin: 8px 0 0 0;
  opacity: 0.5;
}

.vpay__input:focus {
  outline: none;
}

.vpay__input::placeholder {
  color: #ccc;
}

.vpay__input--small {
  padding: 8px 12px;
  text-align: left;
  font-size: 16px;
}

.vpay__divider {
  margin: 16px 16px 0 16px;
  border: 0;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}

.vpay__calendar {
  width: 100% !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  box-sizing: border-box !important;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1), 0 1px 1px rgba(0, 0, 0, 0.2) !important;
}

.vpay__verification-instructions {
  text-align: center;
  font-size: 20px;
  padding: 0;
  margin: 0 0 20px 0;
}

.vpay__verification-instructions-icon {
  font-size: 48px;
  margin: 0 0 20px 0;
}

.vpay__verification-code {
  width: 240px;
  margin: 0 auto;
}

.vpay__mobile-number--disabled {
  border: 0;
}

.vpay__receipt-button,
.vpay__next-button {
  display: block;
  margin: 0 auto;
}

::placeholder {
  color: white;
}

/*
		
		Terms & Conditions
		
	*/

.vpay__title-bar {
  margin: 0;
  padding: 16px 0;
}

.vpay__title-bar--collapsed {
  padding: 0 0 4px 0;
}

.vpay__title-bar-close {
  margin-right: 16px;
  width: 29px;
  height: 29px;
  top: 0;
  float: left;
  color: #409eff;
  cursor: pointer;
}

.vpay__title-bar-close:hover {
  opacity: 0.75;
}

.vpay__title-bar-close ion-icon {
  margin: 0;
}

.vpay__title-bar-print {
  float: right;
}

.vpay__icon-button {
  width: auto;
  height: auto;
  border-radius: 50%;
  color: #409eff;
  cursor: pointer;
  padding: 4px;
  transition: background-color 250ms, opacity 250ms;
}

.vpay__icon-button:hover {
  opacity: 0.75;
  background-color: rgba(0, 0, 0, 0.1);
}

.vpay__icon-button ion-icon {
  display: block;
  top: 0;
  margin: 0;
  width: 22px;
  height: 22px;
}

.vpay__content-area-inner {
  font-size: 14px;
  padding: 16px;
  max-height: 400px;
  overflow-y: scroll;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.vpay__content-area-inner::-webkit-scrollbar {
  width: 12px;
  background-color: white;
}

.vpay__content-area-inner::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  -webkit-border-radius: 8px;
  border-radius: 8px;
}

.vpay__content-area h1,
.vpay__content-area h2,
.vpay__content-area h3,
.vpay__content-area h4,
.vpay__content-area h5,
.vpay__content-area h6 {
  margin-top: 0;
  font-weight: 600;
}

.vpay__content-area p {
  margin-top: 0;
}

.vpay__content-area p:last-of-type {
  margin-bottom: 0;
}

.vpay__button {
  margin-top: 0;
  font-size: 12px;
}

.vpay__button + .vpay__button {
  margin-left: 16px;
}

.vpay__split-buttons {
  border-radius: 4px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  overflow: auto;
}

.vpay__split-button {
  float: left;
  text-align: center;
  padding: 10px;
  transition: all 0.125s;
  cursor: pointer;
  box-sizing: border-box;
}

.vpay__split-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

/*.vpay__split-button--selected {
		background-color: rgba(0, 0, 0, 0.05);
	}*/

.vpay__summary {
  padding: 12px 12px 0 12px;
  background-color: rgba(0, 0, 0, 0.025);
  border-radius: 4px;
  margin-bottom: 16px;
}

.vpay__summary .el-col .vpay__input-container {
  padding: 0;
}

.vpay__summary .el-col {
  margin-bottom: 12px;
}

.vpay__summary-label {
  font-size: 12px;
  font-weight: 600;
}

.vpay__summary-item {
  margin: 0;
  font-size: 14px;
}

.vpay_success-icon {
  display: block;
  margin: 16px auto;
  height: 128px;
  width: 128px;
  top: 0;
  color: #fdd835;
}

.vpay__success-title {
  text-align: center;
}

.vpay__success-description {
  text-align: center;
}

.vpay__success-receipt {
  text-align: center;
  opacity: 0.5;
}

.vpay__editable-block {
  position: relative;
}

.vpay__editable-block-edit-button {
  position: absolute;
  top: 6px;
  right: 12px;
}

/*
		
		Alert
		
	*/

.el-message {
  box-shadow: 0 2px 32px rgba(0, 0, 0, 0.05), 0 1px 4px rgba(0, 0, 0, 0.15);
}

/*
		
		Footer
		
	*/

footer {
  padding: 32px 0 0 0;
  text-align: center;
}

.powered-by-link {
  display: block;
  overflow: auto;
}

.powered-by-logo {
  max-width: 160px;
  margin: 20px auto;
}

.powered-by {
  display: inline-block;
  margin-right: 16px;
}

.logged-in-as {
}

.powered-by,
.logged-in-as {
  font-size: 12px;
  text-align: center;
  opacity: 0.5;
  user-select: none;
  /*margin: 0 0 20px 0;*/
}

/*
		
		Google Places
		
	*/

.pac-container {
  border-radius: 4px;
}

.pac-item {
  padding: 0 8px !important;
  line-height: 40px !important;
}

.pac-icon {
  margin-top: 10px;
}

.pac-logo:after {
  display: none;
  padding: 4px;
  height: 25px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  background-position: center right 5px;
}

/*
		
		Element Overrides
		
	*/

.el-collapse {
  border: 0;
}

.el-collapse-item__content {
  margin: 0;
  padding: 0;
}

.el-collapse-item__header,
.el-collapse-item__wrap {
  border: 0;
}

/*
		
		Saved Card
		
	*/

.saved-card__checkbox {
  width: 100%;
  margin: 0 0 16px 0;
  line-height: 24px;
}

.saved-card__checkbox:last-of-type {
  margin-bottom: 0;
}

.saved-card__image {
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  height: 24px;
  margin-right: 8px;
}

.saved-card__description {
}
</style>
